import React,{useEffect,useState}from'react';
import{useParams}from'react-router-dom';
import logo from'./certLogo.js';
async function api(u){const r=await fetch(u,{credentials:'include'}),j=await r.json().catch(()=>({}));if(!r.ok)throw Error(j.error||'Request failed');return j}
const MONTHS=['January','February','March','April','May','June','July','August','September','October','November','December'];
const fmt=d=>{const m=/^(\d{4})-(\d{2})-(\d{2})/.exec(d||'');return m?MONTHS[+m[2]-1]+' '+(+m[3])+', '+m[1]:(d||'')};
const NAVY='#1A3A6B',ORANGE='#F5921E';
const CSS=`
.cert-wrap{overflow-x:auto;padding:12px 0}
.cert-sheet{width:11in;height:8.5in;box-sizing:border-box;position:relative;background:#fff;margin:0 auto;color:#1f2937;font-family:Georgia,'Times New Roman',serif;box-shadow:0 2px 14px rgba(0,0,0,.18)}
.cert-frame{position:absolute;inset:.22in;border:.14in solid var(--accent);box-sizing:border-box}
.cert-frame2{position:absolute;inset:.5in;border:2px solid var(--accent2);box-sizing:border-box}
.cert-body{position:absolute;inset:.62in .8in .55in;display:flex;flex-direction:column;align-items:center;text-align:center}
.cert-logo{height:1.5in;margin-top:.02in}
.cert-pill{margin-top:.12in;padding:.04in .22in;border-radius:99px;background:var(--accent);color:#fff;font:700 11pt Arial,sans-serif;letter-spacing:.2em}
.cert-title{margin:.22in 0 0;font-size:31pt;font-weight:700;color:${NAVY};letter-spacing:.05em}
.cert-small{margin-top:.1in;font:12pt Arial,sans-serif;color:#4b5563}
.cert-name{margin-top:.04in;padding:0 .5in .02in;font-size:35pt;font-style:italic;color:${NAVY};border-bottom:2px solid var(--accent2)}
.cert-text{margin-top:.2in;max-width:7.9in;font:12.5pt/1.45 Arial,sans-serif;color:#374151}
.cert-course{margin-top:.2in;font:700 17pt Arial,sans-serif;color:${NAVY}}
.cert-facts{margin-top:.2in;display:flex;gap:.45in;font:10.5pt Arial,sans-serif;color:#374151}
.cert-facts b{display:block;font-size:8.5pt;letter-spacing:.12em;color:#6b7280;font-weight:700}
.cert-sign{margin-top:auto;width:100%;display:flex;justify-content:space-between;align-items:flex-end;font:10pt Arial,sans-serif;color:#374151}
.cert-sign div{width:3.7in}
.cert-line{border-top:1.5px solid #374151;padding-top:.04in}
.cert-sign .sig{height:.42in;line-height:.42in}
.cert-foot{margin-top:.14in;font:8pt Arial,sans-serif;color:#6b7280}
.cert-void{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font:900 110pt Arial,sans-serif;color:rgba(185,28,28,.22);transform:rotate(-20deg);pointer-events:none}
.cert-bar{display:flex;gap:10px;align-items:center;justify-content:center;margin:8px 0}
@page{size:letter landscape;margin:0}
@media print{
  body *{visibility:hidden!important}
  .cert-sheet,.cert-sheet *{visibility:visible!important}
  .cert-sheet{position:fixed;left:0;top:0;margin:0;box-shadow:none;-webkit-print-color-adjust:exact;print-color-adjust:exact}
  .cert-bar{display:none!important}
}`;
export function CertificateSheet({c}){
  const dem=c.cert_type==='dementia_initial';
  const accent=dem?ORANGE:NAVY,accent2=dem?NAVY:ORANGE;
  return <div className="cert-sheet" style={{'--accent':accent,'--accent2':accent2}}>
    <div className="cert-frame"/><div className="cert-frame2"/>
    <div className="cert-body">
      <img className="cert-logo" src={logo} alt="Jybek HomeCare Services"/>
      <div className="cert-pill">{dem?'DEMENTIA CARE CERTIFICATION':'PCA ONBOARDING CERTIFICATION'}</div>
      <h1 className="cert-title">Certificate of Completion</h1>
      <div className="cert-small">This certifies that</div>
      <div className="cert-name">{c.employee_name}</div>
      {dem
        ?<div className="cert-text">has successfully completed {c.hours||6} hours of initial dementia care training covering Alzheimer's disease and dementia, person-centered care, assessment and care planning, activities of daily living, and dementia-related behaviors and communication, and has demonstrated related competency as confirmed by a Jybek supervisor.</div>
        :<div className="cert-text">has successfully completed all {c.lessons_total} modules of the Personal Care Assistant onboarding program, passed every module assessment, and has been observed and verified by a Jybek supervisor in {c.skills_passed} required PCA skills competencies.</div>}
      <div className="cert-course">{dem?'Initial Dementia Care Training':'PCA Onboarding Program'}</div>
      <div className="cert-facts">
        <span><b>COMPLETED</b>{fmt(c.completion_date)}</span>
        {dem&&<span><b>TRAINING HOURS</b>{c.hours||6}</span>}
        <span><b>CERTIFICATE NO.</b>{c.cert_no}</span>
      </div>
      <div className="cert-sign">
        <div><div className="sig"></div><div className="cert-line">{c.signer.name}<br/>{c.signer.title}</div></div>
        <div><div className="sig" style={{fontSize:'12pt',fontFamily:'Arial,sans-serif',fontStyle:'normal'}}>{fmt(c.issued_date)}</div><div className="cert-line">Date issued</div></div>
      </div>
      <div className="cert-foot">Feel At HomeCare LLC DBA Jybek HomeCare Services · 15 Constitution Drive, Bedford, NH 03110{dem?' · Content addresses the topics listed in NH RSA 151:47 to 151:50.':''}</div>
    </div>
    {c.voided&&<div className="cert-void">VOID</div>}
  </div>
}
export default function Certificate(){
  const{id}=useParams();const[c,setC]=useState(null),[e,setE]=useState('');
  useEffect(()=>{api('/api/certificates/'+id).then(setC).catch(x=>setE(x.message))},[id]);
  if(e)return <div className="p-5"><div className="bg-red-50 p-3 rounded-lg text-red-800">{e}</div></div>;
  if(!c)return <div className="p-5 text-slate-500">Loading…</div>;
  return <div className="p-3">
    <style>{CSS}</style>
    <div className="cert-bar">
      <button className="rounded-lg bg-slate-900 px-4 py-2 font-bold text-white" onClick={()=>window.print()}>Print or Save as PDF</button>
      <button className="underline text-sm" onClick={()=>window.history.back()}>Back</button>
      {c.voided&&<span className="text-red-700 font-bold">This certificate was voided: {c.void_reason}</span>}
    </div>
    <div className="cert-wrap"><CertificateSheet c={c}/></div>
    <p className="cert-bar text-xs text-slate-500">In the print window, set Layout to Landscape and turn on Background graphics.</p>
  </div>
}
export function MyCertificates(){
  const[rows,setRows]=useState(null),[e,setE]=useState('');
  useEffect(()=>{api('/api/certificates/my').then(setRows).catch(x=>setE(x.message))},[]);
  return <div className="p-5 space-y-4">
    <h1 className="text-3xl font-black">My Certificates</h1>
    {e&&<div className="bg-red-50 p-3 rounded-lg text-red-800">{e}</div>}
    {rows&&!rows.length&&<p className="text-slate-600">No certificates yet. A certificate is issued after you finish a course and your supervisor confirms your skills.</p>}
    <div className="grid gap-3 md:grid-cols-2">
      {(rows||[]).map(c=><a key={c.id} href={'/certificate/'+c.id} className="rounded-2xl border bg-white p-4 block">
        <div className="text-lg font-black">{c.type_label}</div>
        <div className="text-sm text-slate-600">Completed {fmt(c.completion_date)} · {c.cert_no}</div>
        <div className="mt-2 text-sm font-bold text-blue-800">Open certificate</div>
      </a>)}
    </div>
  </div>
}
